// // // // import React from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import Confetti from 'react-confetti';

// // // // export default function Home() {
// // // //   // Grab the window size so the confetti covers the whole screen
// // // //   const width = window.innerWidth;
// // // //   const height = window.innerHeight;

// // // //   return (
// // // //     <div style={{ position: 'relative', overflow: 'hidden', minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
// // // //       {/* Confetti Animation */}
// // // //       <Confetti 
// // // //         width={width} 
// // // //         height={height} 
// // // //         numberOfPieces={250} 
// // // //         gravity={0.15}
// // // //       />
      
// // // //       {/* Main Content */}
// // // //       <div style={{ zIndex: 1, position: 'relative', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: '40px', borderRadius: '15px' }}>
// // // //         <h1 style={{ fontSize: '3.5rem', color: '#6b21a8', margin: '0 0 10px 0' }}>
// // // //           Happy Birthday, Boss! 🎂
// // // //         </h1>
// // // //         <p style={{ fontSize: '1.2rem', color: '#4b5563', maxWidth: '600px', margin: '0 auto 30px auto', lineHeight: '1.6' }}>
// // // //           Welcome to your global birthday bash! Your team from all over the world has gathered here to celebrate your amazing leadership. 
// // // //         </p>
        
// // // //         {/* Navigation Buttons */}
// // // //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
// // // //           <Link to="/messages" style={buttonStyle}>
// // // //             💌 Read & Drop Messages
// // // //           </Link>
// // // //           <Link to="/avatar" style={buttonStyle}>
// // // //             🧑‍🎨 Create Party Avatar
// // // //           </Link>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // // Styling for the Call-to-Action buttons
// // // // const buttonStyle = {
// // // //   padding: '15px 30px',
// // // //   backgroundColor: '#9333ea',
// // // //   color: 'white',
// // // //   textDecoration: 'none',
// // // //   borderRadius: '8px',
// // // //   fontWeight: 'bold',
// // // //   fontSize: '1.1rem',
// // // //   boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
// // // //   transition: 'transform 0.2s'
// // // // };





// // // // import React from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import Confetti from 'react-confetti';

// // // // export default function Home() {
// // // //   const width = window.innerWidth;
// // // //   const height = window.innerHeight;

// // // //   return (
// // // //     <div className="home-hero">
// // // //       <Confetti width={width} height={height} numberOfPieces={150} colors={['#FFD700', '#FFF', '#9370DB']} />
      
// // // //       <div className="hero-content">
// // // //         <h1 className="gold-text">Happy Birthday, Boss!</h1>
// // // //         <p className="hero-subtitle">
// // // //           A milestone celebration for a visionary leader. Step inside to explore her journey, share your testimonies, and drop a golden wish!
// // // //         </p>
        
// // // //         <div className="action-buttons">
// // // //           <Link to="/messages" className="btn-gold">💌 Spin the Messages</Link>
// // // //           <Link to="/avatar" className="btn-outline">🧑‍🎨 Dress Your Avatar</Link>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }


// // // import React, { useState, useEffect, useRef } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import Confetti from 'react-confetti';
// // // import './Home.css';

// // // export default function Home() {
// // //   const [windowSize, setWindowSize] = useState({
// // //     width: window.innerWidth,
// // //     height: window.innerHeight
// // //   });
// // //   const [activeSection, setActiveSection] = useState('home');
// // //   const sectionRefs = useRef({});

// // //   useEffect(() => {
// // //     const handleResize = () => {
// // //       setWindowSize({
// // //         width: window.innerWidth,
// // //         height: window.innerHeight
// // //       });
// // //     };
// // //     window.addEventListener('resize', handleResize);
// // //     return () => window.removeEventListener('resize', handleResize);
// // //   }, []);

// // //   const scrollToSection = (sectionId) => {
// // //     setActiveSection(sectionId);
// // //     const element = document.getElementById(sectionId);
// // //     if (element) {
// // //       element.scrollIntoView({ behavior: 'smooth' });
// // //     }
// // //   };

// // //   return (
// // //     <div className="app-container">
// // //       {/* Confetti - only on home section */}
// // //       {activeSection === 'home' && (
// // //         <Confetti 
// // //           width={windowSize.width} 
// // //           height={windowSize.height} 
// // //           numberOfPieces={150} 
// // //           colors={['#FFD700', '#FFF', '#9370DB', '#f5c542', '#b78cf0']}
// // //           recycle={true}
// // //           run={true}
// // //         />
// // //       )}

// // //       {/* Navigation */}
// // //       <nav className="navbar">
// // //         <div className="nav-container">
// // //           <div className="nav-logo">LOGO</div>
// // //           <ul className="nav-menu">
// // //             <li><button onClick={() => scrollToSection('home')} className={activeSection === 'home' ? 'active' : ''}>Home</button></li>
// // //             <li><button onClick={() => scrollToSection('story')} className={activeSection === 'story' ? 'active' : ''}>Our Story</button></li>
// // //             <li><button onClick={() => scrollToSection('details')} className={activeSection === 'details' ? 'active' : ''}>Details</button></li>
// // //             <li><button onClick={() => scrollToSection('gallery')} className={activeSection === 'gallery' ? 'active' : ''}>Gallery</button></li>
// // //             <li><button onClick={() => scrollToSection('highlights')} className={activeSection === 'highlights' ? 'active' : ''}>Highlights</button></li>
// // //             <li><button onClick={() => scrollToSection('gifts')} className={activeSection === 'gifts' ? 'active' : ''}>Gifts</button></li>
// // //             <li><button onClick={() => scrollToSection('wishes')} className={activeSection === 'wishes' ? 'active' : ''}>Well Wishes</button></li>
// // //           </ul>
// // //           <button className="nav-rsvp" onClick={() => scrollToSection('gifts')}>RSVP</button>
// // //         </div>
// // //       </nav>

// // //       {/* HOME SECTION */}
// // //       <section id="home" className="section home-section">
// // //         <div className="hero-content">
// // //           <h1 className="gold-text">GRACE IN MOTION</h1>
// // //           <div className="save-the-date">
// // //             <h2>Save the Date</h2>
// // //             <h3>SEPTMBER 2026</h3>
// // //             <div className="calendar">
// // //               <table>
// // //                 <thead>
// // //                   <tr>
// // //                     <th>Sun</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th>
// // //                   </tr>
// // //                 </thead>
// // //                 <tbody>
// // //                   <tr><td></td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td><td>6</td></tr>
// // //                   <tr><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td><td>12</td><td>13</td></tr>
// // //                   <tr><td>14</td><td>15</td><td>16</td><td>17</td><td>18</td><td>19</td><td>20</td></tr>
// // //                   <tr><td>21</td><td>22</td><td>23</td><td>24</td><td>25</td><td>26</td><td>27</td></tr>
// // //                   <tr><td>28</td><td>29</td><td>30</td><td></td><td></td><td></td><td></td></tr>
// // //                 </tbody>
// // //               </table>
// // //             </div>
// // //           </div>
// // //           <p className="hero-subtitle">
// // //             A milestone celebration for a visionary leader. Step inside to explore her journey, share your testimonies, and drop a golden wish!
// // //           </p>
// // //           <div className="action-buttons">
// // //             <Link to="/messages" className="btn-gold">💌 Spin the Messages</Link>
// // //             <Link to="/avatar" className="btn-outline">🧑‍🎨 Create Your Avatar</Link>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* OUR STORY SECTION */}
// // //       <section id="story" className="section story-section">
// // //         <div className="section-content">
// // //           <h2 className="section-title">Our Story</h2>
// // //           <div className="story-grid">
// // //             <div className="story-text">
// // //               <h3>University</h3>
// // //               <p>
// // //                 I met her at the University of Lagos, where we were both pursuing our 
// // //                 dreams. It was a chance encounter that would change everything. We 
// // //                 started as classmates, became friends, and eventually found love in 
// // //                 the most unexpected way. Through the years, we've built a beautiful 
// // //                 life together, filled with laughter, growth, and unwavering support 
// // //                 for each other's dreams.
// // //               </p>
// // //               <p>
// // //                 Today, as we celebrate this golden milestone, we look back at the 
// // //                 journey that brought us here - from that first conversation to this 
// // //                 moment of celebration. Every challenge and triumph has shaped our 
// // //                 story, and we're grateful for every chapter.
// // //               </p>
// // //             </div>
// // //             <div className="story-image">
// // //               <div className="image-placeholder">
// // //                 <i className="fas fa-heart"></i>
// // //                 <span>50 Years of Love</span>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* DETAILS SECTION */}
// // //       <section id="details" className="section details-section">
// // //         <div className="section-content">
// // //           <h2 className="section-title">Event Details</h2>
// // //           <div className="details-grid">
// // //             <div className="detail-card">
// // //               <i className="fas fa-calendar-day"></i>
// // //               <h3>Date</h3>
// // //               <p>June 20, 2026</p>
// // //               <span>6:00 PM - 11:59 PM</span>
// // //             </div>
// // //             <div className="detail-card">
// // //               <i className="fas fa-map-marker-alt"></i>
// // //               <h3>Venue</h3>
// // //               <p>Eko Hotels & Suites</p>
// // //               <span>Victoria Island, Lagos</span>
// // //             </div>
// // //             <div className="detail-card">
// // //               <i className="fas fa-tshirt"></i>
// // //               <h3>Dress Code</h3>
// // //               <p>Golden Glamour</p>
// // //               <span>Black & Gold Theme</span>
// // //             </div>
// // //             <div className="detail-card">
// // //               <i className="fas fa-music"></i>
// // //               <h3>Entertainment</h3>
// // //               <p>Live Band & DJ</p>
// // //               <span>Featuring special performances</span>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* GALLERY SECTION */}
// // //       <section id="gallery" className="section gallery-section">
// // //         <div className="section-content">
// // //           <h2 className="section-title">Gallery</h2>
// // //           <div className="gallery-grid">
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 1" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 2" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 3" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 4" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 5" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 6" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 7" /></div>
// // //             <div className="gallery-item"><img src="/api/placeholder/300/300" alt="Gallery 8" /></div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* HIGHLIGHTS SECTION */}
// // //       <section id="highlights" className="section highlights-section">
// // //         <div className="section-content">
// // //           <h2 className="section-title">Highlights</h2>
// // //           <div className="highlights-grid">
// // //             <div className="highlight-card">
// // //               <div className="highlight-number">50</div>
// // //               <h3>Years of Excellence</h3>
// // //               <p>A legacy of leadership and inspiration</p>
// // //             </div>
// // //             <div className="highlight-card">
// // //               <div className="highlight-number">500+</div>
// // //               <h3>Lives Impacted</h3>
// // //               <p>Mentored and inspired professionals</p>
// // //             </div>
// // //             <div className="highlight-card">
// // //               <div className="highlight-number">25+</div>
// // //               <h3>Awards Received</h3>
// // //               <p>Recognitions for outstanding contributions</p>
// // //             </div>
// // //             <div className="highlight-card">
// // //               <div className="highlight-number">∞</div>
// // //               <h3>Unlimited Love</h3>
// // //               <p>From family, friends, and colleagues</p>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* GIFTS / RSVP SECTION */}
// // //       <section id="gifts" className="section gifts-section">
// // //         <div className="section-content">
// // //           <h2 className="section-title">Gifts & RSVP</h2>
// // //           <div className="gifts-container">
// // //             <div className="gift-box">
// // //               <h3>🎁 Gift Registry</h3>
// // //               <p>Your presence is the greatest gift, but if you wish to give, here are some suggestions:</p>
// // //               <ul>
// // //                 <li>📚 Book Collection</li>
// // //                 <li>✈️ Travel Voucher</li>
// // //                 <li>🎨 Art & Decor</li>
// // //                 <li>💝 Charity Donation</li>
// // //               </ul>
// // //             </div>
// // //             <div className="rsvp-box">
// // //               <h3>📋 RSVP</h3>
// // //               <p>Kindly confirm your attendance by June 10, 2026</p>
// // //               <form className="rsvp-form">
// // //                 <input type="text" placeholder="Your Name" />
// // //                 <input type="email" placeholder="Email Address" />
// // //                 <select>
// // //                   <option>Will attend</option>
// // //                   <option>Will not attend</option>
// // //                   <option>Maybe</option>
// // //                 </select>
// // //                 <button type="submit" className="btn-gold">Submit RSVP</button>
// // //               </form>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* WELL WISHES SECTION */}
// // //       <section id="wishes" className="section wishes-section">
// // //         <div className="section-content">
// // //           <h2 className="section-title">Well Wishes</h2>
// // //           <div className="wishes-container">
// // //             <div className="featured-wish">
// // //               <div className="wish-card featured">
// // //                 <p className="wish-text">
// // //                   "Today marks the beginning of a lifelong partnership built on love, 
// // //                   purpose, and commitment. May your union be strong in every season, 
// // //                   your home filled with peace, and your journey crowned with lasting 
// // //                   joy and fulfillment. Build with patience. Stand with unity. Love 
// // //                   without limits. Congratulations."
// // //                 </p>
// // //                 <div className="wish-author">
// // //                   <strong>Raphael Chiemeka</strong>
// // //                   <span>⭐ 5.0</span>
// // //                 </div>
// // //               </div>
// // //             </div>
            
// // //             <div className="wishes-grid">
// // //               <div className="wish-card">
// // //                 <p>"Happy 50th Birthday! You're an inspiration to us all."</p>
// // //                 <div className="wish-author"><strong>Chidi Okonkwo</strong></div>
// // //               </div>
// // //               <div className="wish-card">
// // //                 <p>"Wishing you continued success and happiness. Cheers to 50 years!"</p>
// // //                 <div className="wish-author"><strong>Amara Nwosu</strong></div>
// // //               </div>
// // //               <div className="wish-card">
// // //                 <p>"Your leadership has shaped so many careers. Thank you for everything!"</p>
// // //                 <div className="wish-author"><strong>Kunle Adeyemi</strong></div>
// // //               </div>
// // //               <div className="wish-card">
// // //                 <p>"May this new chapter bring you even more joy and fulfillment."</p>
// // //                 <div className="wish-author"><strong>Zainab Bello</strong></div>
// // //               </div>
// // //             </div>
            
// // //             <Link to="/messages" className="btn-outline view-all-wishes">
// // //               View all & add yours <i className="fas fa-arrow-right"></i>
// // //             </Link>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Footer */}
// // //       <footer className="footer">
// // //         <div className="footer-content">
// // //           <p>© 2026 Golden Jubilee Celebration</p>
// // //           <div className="social-links">
// // //             <a href="#"><i className="fab fa-instagram"></i></a>
// // //             <a href="#"><i className="fab fa-facebook"></i></a>
// // //             <a href="#"><i className="fab fa-twitter"></i></a>
// // //             <a href="#"><i className="fab fa-youtube"></i></a>
// // //           </div>
// // //         </div>
// // //       </footer>
// // //     </div>
// // //   );
// // // }

// // //Gallery

// // import React, { useState, useEffect, useRef, useCallback } from 'react';
// // import { Link } from 'react-router-dom';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import './Home.css';

// // /**
// //  * ── Single source of truth ──────────────────────────────────────────────
// //  */
// // const CONFIG = {
// //   celebrantName: 'Her',
// //   age: 50,
// //   eventDate: new Date('2026-09-23T18:00:00+01:00'),
// //   eventEndLabel: '11:59 PM',
// //   venueName: 'Bay 2',
// //   venueArea: 'Aseese Base',
// //   dressCode: 'Golden Glamour',
// //   dressCodeSub: 'Black & Gold Attire',
// //   rsvpDeadline: new Date('2026-09-10T23:59:59+01:00'),
// // };

// // const dateFormatter = new Intl.DateTimeFormat('en-US', {
// //   month: 'long',
// //   day: 'numeric',
// //   year: 'numeric',
// // });

// // /* ── Inline Icons ───────── */
// // const Icon = {
// //   Calendar: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <rect x="3" y="5" width="18" height="16" rx="2" />
// //       <path d="M8 3v4M16 3v4M3 10h18" strokeLinecap="round" />
// //     </svg>
// //   ),
// //   Pin: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <path d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21Z" />
// //       <circle cx="12" cy="9.5" r="2.4" />
// //     </svg>
// //   ),
// //   Attire: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <path d="M8 4 4 7l2 3 2-1.4V20h8V8.6L18 10l2-3-4-3-2 2h-4L8 4Z" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   Music: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <path d="M9 18V5l11-2v13" strokeLinecap="round" strokeLinejoin="round" />
// //       <circle cx="6" cy="18" r="3" />
// //       <circle cx="17" cy="16" r="3" />
// //     </svg>
// //   ),
// //   Gift: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <rect x="3" y="9" width="18" height="12" rx="1" />
// //       <path d="M3 9h18M12 9v12M12 9C9.5 9 8 7.3 8 5.7 8 4.2 9 3 10.3 3 12 3 12 6 12 9ZM12 9c2.5 0 4-1.7 4-3.3C16 4.2 15 3 13.7 3 12 3 12 6 12 9Z" />
// //     </svg>
// //   ),
// //   Mail: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <rect x="3" y="5" width="18" height="14" rx="2" />
// //       <path d="m4 6 8 6 8-6" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   Arrow: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...p}>
// //       <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   ChevronDown: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// //       <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   Star: (p) => (
// //     <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
// //       <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.6l-5.9 3 1.2-6.5-4.8-4.6 6.6-.9L12 2.5Z" />
// //     </svg>
// //   ),
// //   Instagram: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <rect x="3" y="3" width="18" height="18" rx="5" />
// //       <circle cx="12" cy="12" r="4" />
// //       <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
// //     </svg>
// //   ),
// //   Facebook: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <path d="M15 21v-8h3l.5-4H15V7c0-1.1.3-2 2-2h1.5V1.4C18.2 1.3 17 1.2 15.7 1.2 12.9 1.2 11 3 11 6v3H8v4h3v8Z" />
// //     </svg>
// //   ),
// //   Crest: (p) => (
// //     <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
// //       <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
// //       <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
// //     </svg>
// //   ),
// //   Youtube: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
// //       <rect x="2.5" y="5.5" width="19" height="13" rx="3.5" />
// //       <path d="M10.5 9.5v5l4.5-2.5-4.5-2.5Z" fill="currentColor" stroke="none" />
// //     </svg>
// //   ),
// // };

// // /* ── The Royal Flanks ──────────────────────────────────────────────────
// //    Rebuilt so each flank is a real box (see .royal-flank in Home.css)
// //    instead of one absolutely-positioned overlay pinned with calc() math.

// //    - RoyalFlankDefs: the shared <symbol>-style SVG library (<defs>), 
// //      rendered exactly once anywhere in the tree. It's invisible (0x0),
// //      so its position in the DOM doesn't matter.
// //    - RoyalFlank: one flank's actual content. The SAME markup is used for
// //      both sides — the right flank is simply mirrored in CSS via
// //      `.royal-flank--right { transform: scaleX(-1); }`, so there's no need
// //      to hand-author separate left/right constellation coordinates anymore.
// // */
// // const FloralOrnament = () => (
// //   <>
// //     <svg className="wreath-icon" viewBox="-50 -50 100 100"><use href="#rf-wreath" /></svg>
// //     <svg className="wing-icon glow-pulse" viewBox="0 0 30 44"><use href="#rf-wing" /></svg>
// //     <svg className="bloom-icon bloom-icon--1" viewBox="0 0 40 40"><use href="#rf-rose" /></svg>
// //     <svg className="bloom-icon bloom-icon--2" viewBox="0 0 40 40"><use href="#rf-leaf" /></svg>
// //     <svg className="bloom-icon bloom-icon--3" viewBox="0 0 40 40"><use href="#rf-leaf" /></svg>
// //   </>
// // );

// // const RoyalFlankDefs = () => (
// //   <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
// //     <defs>
// //       <g id="rf-rose">
// //         <g stroke="#c6a15b" strokeWidth="1" fill="none" opacity="0.85">
// //           <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(0 20 20)" />
// //           <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(60 20 20)" />
// //           <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(120 20 20)" />
// //           <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(180 20 20)" />
// //           <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(240 20 20)" />
// //           <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(300 20 20)" />
// //         </g>
// //         <circle cx="20" cy="20" r="3" fill="#c6a15b" opacity="0.5" />
// //       </g>

// //       <g id="rf-leaf">
// //         <path d="M20 4 C30 12, 30 28, 20 36 C10 28, 10 12, 20 4 Z" stroke="#c6a15b" strokeWidth="1" fill="rgba(198,161,91,0.08)" />
// //         <line x1="20" y1="6" x2="20" y2="34" stroke="#c6a15b" strokeWidth="0.75" opacity="0.6" />
// //       </g>

// //       <g id="rf-wing">
// //         <g stroke="#c6a15b" strokeWidth="1" fill="rgba(198,161,91,0.06)">
// //           <path d="M0 40 C10 30, 15 15, 8 0 C20 10, 22 25, 14 40 Z" transform="rotate(-24 0 40)" />
// //           <path d="M0 40 C12 32, 18 18, 12 2 C24 14, 25 28, 16 40 Z" transform="rotate(-12 0 40)" />
// //           <path d="M0 40 C14 34, 20 20, 16 4 C27 17, 27 30, 18 40 Z" transform="rotate(0 0 40)" />
// //           <path d="M0 40 C14 34, 20 20, 16 4 C27 17, 27 30, 18 40 Z" transform="rotate(12 0 40)" />
// //           <path d="M0 40 C12 32, 18 18, 12 2 C24 14, 25 28, 16 40 Z" transform="rotate(24 0 40)" />
// //         </g>
// //       </g>

// //       <g id="rf-wreath">
// //         <use href="#rf-leaf" transform="rotate(0)   translate(0,-38) scale(0.55)" />
// //         <use href="#rf-rose" transform="rotate(45)  translate(0,-38) scale(0.5)" />
// //         <use href="#rf-leaf" transform="rotate(90)  translate(0,-38) scale(0.55)" />
// //         <use href="#rf-rose" transform="rotate(135) translate(0,-38) scale(0.5)" />
// //         <use href="#rf-leaf" transform="rotate(180) translate(0,-38) scale(0.55)" />
// //         <use href="#rf-rose" transform="rotate(225) translate(0,-38) scale(0.5)" />
// //         <use href="#rf-leaf" transform="rotate(270) translate(0,-38) scale(0.55)" />
// //         <use href="#rf-rose" transform="rotate(315) translate(0,-38) scale(0.5)" />
// //       </g>
// //     </defs>
// //   </svg>
// // );

// // const RoyalFlank = ({ side }) => (
// //   <div className={`royal-flank royal-flank--${side}`} aria-hidden="true">
// //     <div className="floral-layer">
// //       <FloralOrnament />
// //     </div>

// //     <div className="stardust-field">
// //       <span className="north-star" />
// //     </div>

// //     <svg className="constellation-lines" viewBox="0 0 300 800" preserveAspectRatio="none">
// //       <polyline
// //         points="60,90 130,190 80,330 170,430 100,570 150,690"
// //         fill="none"
// //         stroke="#c6a15b"
// //         strokeWidth="1"
// //         strokeOpacity="0.3"
// //       />
// //     </svg>
// //   </div>
// // );

// // /* ── 3D Premium Particles Component ───────── */
// // const PremiumParticles = ({ activeSection, windowSize }) => {
// //   const isMobile = windowSize.width > 0 && windowSize.width < 768;
// //   const particleCount = isMobile ? 24 : 45; 

// //   const particles = React.useMemo(() => {
// //     return Array.from({ length: particleCount }).map((_, i) => {
// //       const types = ['particle-orb', 'particle-ribbon', 'particle-ribbon', 'particle-shard'];
// //       const type = types[Math.floor(Math.random() * types.length)];

// //       const size = Math.random() * 20 + 8;
// //       const width = type === 'particle-ribbon' ? size * (Math.random() * 1.5 + 2) : size;

// //       // THE "GOLDILOCKS" SPEED (2.5s to 4.5s)
// //       // Fast enough to not drag on live servers, slow enough to look luxurious.
// //       const duration = Math.random() * 2.0 + 2.5; 
      
// //       const delay = Math.random() * -8;
// //       const drift = (Math.random() - 0.5) * 40;
// //       const rotX = `${Math.random() * 1080}deg`;
// //       const rotY = `${Math.random() * 1080}deg`;
// //       const rotZ = `${Math.random() * 1080}deg`;

// //       return {
// //         id: i,
// //         type,
// //         style: {
// //           left: `${Math.random() * 100}%`,
// //           width: `${width}px`,
// //           height: `${size}px`,
// //           animationDuration: `${duration}s`,
// //           animationDelay: `${delay}s`,
// //           filter: 'none',
// //           '--drift': drift,
// //           '--rotX': rotX,
// //           '--rotY': rotY,
// //           '--rotZ': rotZ,
// //         }
// //       };
// //     });
// //   }, [particleCount]);

// //   return (
// //     <div
// //       className="premium-particles-container"
// //       data-section={activeSection}
// //     >
// //       {particles.map((p) => (
// //         <div key={p.id} className={`particle ${p.type}`} style={p.style} />
// //       ))}
// //     </div>
// //   );
// // };
// // /* ── Custom Royal Select Dropdown ───────── */
// // const CustomSelect = ({ value, onChange, options }) => {
// //   const [isOpen, setIsOpen] = useState(false);
// //   const dropdownRef = useRef(null);

// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);
// //     };
// //     document.addEventListener('mousedown', handleClickOutside);
// //     return () => document.removeEventListener('mousedown', handleClickOutside);
// //   }, []);

// //   return (
// //     <div className="custom-select-wrapper" ref={dropdownRef}>
// //       <div className={`custom-select-header ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
// //         <span>{value}</span>
// //         <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
// //           <Icon.ChevronDown width="16" height="16" />
// //         </motion.div>
// //       </div>
// //       <AnimatePresence>
// //         {isOpen && (
// //           <motion.ul
// //             className="custom-select-list"
// //             initial={{ opacity: 0, y: -10 }}
// //             animate={{ opacity: 1, y: 0 }}
// //             exit={{ opacity: 0, y: -10 }}
// //             transition={{ duration: 0.2 }}
// //           >
// //             {options.map((opt) => (
// //               <li key={opt} onClick={() => { onChange(opt); setIsOpen(false); }}>
// //                 {opt}
// //               </li>
// //             ))}
// //           </motion.ul>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // const TRACKED_SECTIONS = ['home', 'save-the-date', 'journey', 'details', 'gallery', 'highlights', 'gifts', 'wishes'];

// // function useCountdown(target) {
// //   const [remaining, setRemaining] = useState(() => target.getTime() - Date.now());

// //   useEffect(() => {
// //     const tick = () => setRemaining(target.getTime() - Date.now());
// //     tick();
// //     const interval = setInterval(tick, 1000 * 30);
// //     return () => clearInterval(interval);
// //   }, [target]);

// //   const clamped = Math.max(remaining, 0);
// //   const days = Math.floor(clamped / 86400000);
// //   const hours = Math.floor((clamped % 86400000) / 3600000);
// //   const minutes = Math.floor((clamped % 3600000) / 60000);
// //   return { days, hours, minutes, isPast: remaining <= 0 };
// // }

// // export default function Home() {
// //   const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
// //   const [activeSection, setActiveSection] = useState('home');
// //   const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
// //   const [rsvp, setRsvp] = useState({ name: '', email: '', attending: 'Will attend' });
// //   const [rsvpSubmitted, setRsvpSubmitted] = useState(false);
// //   const sectionEls = useRef({});
// //   const countdown = useCountdown(CONFIG.eventDate);

// //   useEffect(() => {
// //     const handleResize = () =>
// //       setWindowSize({ width: window.innerWidth, height: window.innerHeight });
// //     handleResize();
// //     window.addEventListener('resize', handleResize);

// //     const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
// //     setPrefersReducedMotion(motionQuery.matches);
// //     const handleMotion = (e) => setPrefersReducedMotion(e.matches);
// //     motionQuery.addEventListener('change', handleMotion);

// //     return () => {
// //       window.removeEventListener('resize', handleResize);
// //       motionQuery.removeEventListener('change', handleMotion);
// //     };
// //   }, []);

// //   useEffect(() => {
// //     const rafRef = { current: null };
// //     const handleScroll = () => {
// //       if (rafRef.current) return;
// //       rafRef.current = requestAnimationFrame(() => {
// //         rafRef.current = null;
// //       });
// //     };
// //     window.addEventListener('scroll', handleScroll, { passive: true });
// //     return () => {
// //       window.removeEventListener('scroll', handleScroll);
// //       if (rafRef.current) cancelAnimationFrame(rafRef.current);
// //     };
// //   }, []);

// //   useEffect(() => {
// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         entries.forEach((entry) => {
// //           if (entry.isIntersecting) setActiveSection(entry.target.id);
// //         });
// //       },
// //       { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
// //     );

// //     TRACKED_SECTIONS.forEach((id) => {
// //       const el = document.getElementById(id);
// //       if (el) {
// //         sectionEls.current[id] = el;
// //         observer.observe(el);
// //       }
// //     });

// //     return () => observer.disconnect();
// //   }, []);

// //   const scrollToSection = useCallback((sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) element.scrollIntoView({ behavior: 'smooth' });
// //   }, []);

// //   const handleRsvpSubmit = (e) => {
// //     e.preventDefault();
// //     if (!rsvp.name.trim() || !rsvp.email.trim()) return;
// //     setRsvpSubmitted(true);
// //   };

// //   return (
// //     <div className="app-container">

// //       {/* FULL 3D FAST PARTICLES FOR ALL DEVICES */}
// //       {!prefersReducedMotion && (
// //         <PremiumParticles
// //           activeSection={activeSection}
// //           windowSize={windowSize}
// //         />
// //       )}

// //       {/* ── HOME SECTION ── */}
// //       <section id="home" className="hero-banner-section">
// //         <div className="hero-image-container">

// //           {/* Shared SVG symbol library — rendered once, referenced by both flanks */}
// //           <RoyalFlankDefs />

// //           {/* THE PORTRAIT ROW: left flank / image / right flank, as real flex children */}
// //           <div className="hero-portrait-row">
// //             <RoyalFlank side="left" />

// //             <div className="hero-image-wrapper">
// //               <img
// //                 src="/assets/photos/hero-portrait.jpg"
// //                 alt="Celebrant portrait"
// //                 className="hero-image"
// //                 loading="eager"
// //                 fetchPriority="high"
// //               />
// //             </div>

// //             <RoyalFlank side="right" />
// //           </div>

// //           <div className="hero-connector" aria-hidden="true">
// //             <div className="hero-connector-badge">
// //               <Icon.Crest />
// //             </div>
// //           </div>

// //           <div className="hero-plaque">
// //             <div className="hero-plaque-inner hero-content">
// //               <span className="hero-badge reveal" style={{ '--delay': '0.1s' }}>
// //                 A Milestone Birthday
// //               </span>
// //               <h1 className="hero-main-title">
// //                 <span className="title-line reveal" style={{ '--delay': '0.25s' }}>Fifty Years of</span>
// //                 <span className="title-line-highlight reveal reveal--shimmer" style={{ '--delay': '0.4s' }}>
// //                   Grace &amp; Purpose
// //                 </span>
// //               </h1>
// //               <p className="hero-description reveal" style={{ '--delay': '0.6s' }}>
// //                 A golden celebration of a life that has shaped, mentored, and
// //                 inspired billions around the world.
// //               </p>
// //               <div className="hero-cta reveal" style={{ '--delay': '0.75s' }}>
// //                 <Link to="/messages" className="btn-gold hero-btn">
// //                   <Icon.Mail width="18" height="18" /> Leave a Message
// //                 </Link>
// //                 <button className="btn-outline hero-btn-outline" onClick={() => scrollToSection('journey')}>
// //                   Discover Her Journey
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

// //       {/* ── SAVE THE DATE SECTION ── */}
// //       <section id="save-the-date" className="welcome-section">
// //         <div className="welcome-wrapper">
// //           <div className="companion-grid">
            
// //             <div className="date-panel">
// //               <span className="date-panel-corner date-panel-corner--tl" aria-hidden="true" />
// //               <span className="date-panel-corner date-panel-corner--tr" aria-hidden="true" />
// //               <span className="date-panel-corner date-panel-corner--bl" aria-hidden="true" />
// //               <span className="date-panel-corner date-panel-corner--br" aria-hidden="true" />

// //               <Icon.Crest className="crest" aria-hidden="true" />

// //               <div className="date-panel-main">
// //                 <span className="eyebrow">Save the Date</span>
// //                 <h2>{dateFormatter.format(CONFIG.eventDate).toUpperCase()}</h2>
// //               </div>

// //               {!countdown.isPast ? (
// //                 <div className="countdown" role="timer" aria-label="Time remaining until the celebration">
// //                   <div className="countdown-unit">
// //                     <span className="countdown-value">{countdown.days}</span>
// //                     <span className="countdown-label">Days</span>
// //                   </div>
// //                   <div className="countdown-unit">
// //                     <span className="countdown-value">{countdown.hours}</span>
// //                     <span className="countdown-label">Hours</span>
// //                   </div>
// //                   <div className="countdown-unit">
// //                     <span className="countdown-value">{countdown.minutes}</span>
// //                     <span className="countdown-label">Minutes</span>
// //                   </div>
// //                 </div>
// //               ) : (
// //                 <p className="countdown-past">The celebration has begun 🎉</p>
// //               )}
// //             </div>

// //             <div className="companion-note">
// //               <span className="date-panel-corner date-panel-corner--tl" aria-hidden="true" />
// //               <span className="date-panel-corner date-panel-corner--tr" aria-hidden="true" />
// //               <span className="date-panel-corner date-panel-corner--bl" aria-hidden="true" />
// //               <span className="date-panel-corner date-panel-corner--br" aria-hidden="true" />

// //              <div className="companion-note-photo">
// //                 <img
// //                   src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=700&h=880&fit=crop"
// //                   alt="A golden birthday celebration toast"
// //                   loading="lazy"
// //                 />
// //               </div>
// //               <div className="companion-note-text">
// //                 <span className="eyebrow">A Note of Welcome</span>
// //                 <p className="welcome-note-quote">
// //                   "Grace amplifies efforts — Great strength, Wisdom, decade after decade."
// //                 </p>
// //                 <span className="welcome-note-attribution">— With deep appreciation, OCOS & LMP</span>
// //               </div>
// //             </div>

// //           </div>

// //           <p className="hero-subtitle">
// //             Step inside to explore her journey, share your testimonies, and add
// //             your golden wish to the wall.
// //           </p>
// //           <div className="action-buttons">
// //             <Link to="/messages" className="btn-gold">Read the Wishes</Link>
// //             <Link to="/avatar" className="btn-outline">Create Your Avatar</Link>
// //           </div>
// //         </div>
// //       </section>

// //       <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

// //       {/* ── HER JOURNEY ── */}
// //       <section id="journey" className="section story-section">
// //         <div className="section-content">
// //           <span className="eyebrow">Her Journey</span>
// //           <h2 className="section-title">Five Decades, One Purpose</h2>

// //           <ol className="timeline">
// //             <li className="timeline-item">
// //               <span className="timeline-index">01</span>
// //               <div>
// //                 <h3>The Foundation</h3>
// //                 <p>
// //                   A curious, determined beginning — the values learned early on
// //                   became the compass for everything that followed.
// //                 </p>
// //               </div>
// //             </li>
// //             <li className="timeline-item">
// //               <span className="timeline-index">02</span>
// //               <div>
// //                 <h3>Building a Career</h3>
// //                 <p>
// //                   Years of showing up, taking on what others avoided, and
// //                   earning trust the honest way.
// //                 </p>
// //               </div>
// //             </li>
// //             <li className="timeline-item">
// //               <span className="timeline-index">03</span>
// //               <div>
// //                 <h3>Leadership &amp; Mentorship</h3>
// //                 <p>
// //                   A door held open for every person who needed one — quietly
// //                   shaping lives far beyond her own.
// //                 </p>
// //               </div>
// //             </li>
// //             <li className="timeline-item">
// //               <span className="timeline-index">04</span>
// //               <div>
// //                 <h3>Today</h3>
// //                 <p>
// //                   Fifty years in, still leading, still mentoring, still the
// //                   first call when someone needs wisdom.
// //                 </p>
// //               </div>
// //             </li>
// //           </ol>
// //         </div>
// //       </section>

// //       <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

// //       {/* ── DETAILS ── */}
// //       <section id="details" className="section details-section">
// //         <div className="section-content">
// //           <span className="eyebrow">Join Us</span>
// //           <h2 className="section-title">Event Details</h2>
// //           <div className="details-grid">
// //             <div className="detail-card">
// //               <Icon.Calendar className="detail-icon" />
// //               <h3>Date</h3>
// //               <p>{dateFormatter.format(CONFIG.eventDate)}</p>
// //               <span>6:00 PM – {CONFIG.eventEndLabel}</span>
// //             </div>
// //             <div className="detail-card">
// //               <Icon.Pin className="detail-icon" />
// //               <h3>Venue</h3>
// //               <p>{CONFIG.venueName}</p>
// //               <span>{CONFIG.venueArea}</span>
// //             </div>
// //             <div className="detail-card">
// //               <Icon.Attire className="detail-icon" />
// //               <h3>Dress Code</h3>
// //               <p>{CONFIG.dressCode}</p>
// //               <span>{CONFIG.dressCodeSub}</span>
// //             </div>
// //             {/* <div className="detail-card">
// //               <Icon.Music className="detail-icon" />
// //               <h3>Entertainment</h3>
// //               <p>Live Band &amp; DJ</p>
// //               <span>Plus a few surprise performances</span>
// //             </div> */}
// //           </div>
// //         </div>
// //       </section>

// //       <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

// //       {/* ── GALLERY ── */}
// //       <section id="gallery" className="section gallery-section">
// //         <div className="section-content">
// //           <span className="eyebrow">Memories</span>
// //           <h2 className="section-title">Gallery</h2>
// //           <div className="gallery-grid">
// //             {[
// //               { file: 'memory-red-gown-portrait.jpg', alt: 'Radiant in a red sequin gown, holding her award' },
// //               { file: 'memory-group-celebration.jpg', alt: 'Surrounded by loved ones in a joyful celebration' },
// //               { file: 'memory-stage-award.jpg', alt: 'On stage receiving the award with her team' },
// //               { file: 'gallery-peach-feather-gown.jpg', alt: 'In a peach beaded gown with feather sleeves' },
// //               { file: 'gallery-white-beaded-gown.jpg', alt: 'In a white beaded gown, side profile' },
// //               { file: 'gallery-black-sequin-gown-turn.jpg', alt: 'In a black sequin gown, mid-turn' },
// //               { file: 'gallery-blue-sequin-seated.jpg', alt: 'Seated in a blue and silver sequin gown' },
// //               { file: 'gallery-brocade-thoughtful.jpg', alt: 'In a blue brocade suit, a thoughtful moment' },
// //             ].map((photo, i) => (
// //               <div className="gallery-item" key={photo.file}>
// //                 <img
// //                   src={`/assets/photos/${photo.file}`}
// //                   alt={photo.alt}
// //                   loading="lazy"
// //                 />
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

// //       {/* ── GIFTS / RSVP ── */}
// //       <section id="gifts" className="section gifts-section">
// //         <div className="section-content">
// //           <span className="eyebrow">Celebrate With Us</span>
// //           <h2 className="section-title">Gifts &amp; RSVP</h2>
// //           <div className="gifts-container">
// //             <div className="gift-box">
// //               <h3><Icon.Gift width="22" height="22" /> Givings</h3>
// //               <p>Offerings & Others</p>
// //               <ul>
// //                 <li>Account Name</li>
// //                 <li>Account Number</li>
// //                 <li>Espee &amp; Code</li>
// //                 <li>God Bless You.</li>
// //               </ul>
// //             </div>

// //             <div className="rsvp-box">
// //               <h3>RSVP</h3>
// //               <p>Kindly confirm your attendance by {dateFormatter.format(CONFIG.rsvpDeadline)}.</p>

// //               {rsvpSubmitted ? (
// //                 <div className="rsvp-confirmation" role="status">
// //                   Thank you, {rsvp.name.split(' ')[0]} — your RSVP is in. See you there!
// //                 </div>
// //               ) : (
// //                 <form className="rsvp-form" onSubmit={handleRsvpSubmit}>
// //                   <label className="sr-only" htmlFor="rsvp-name">Your name</label>
// //                   <input
// //                     id="rsvp-name"
// //                     type="text"
// //                     placeholder="Your Name"
// //                     value={rsvp.name}
// //                     onChange={(e) => setRsvp((r) => ({ ...r, name: e.target.value }))}
// //                     required
// //                   />

// //                   <label className="sr-only" htmlFor="rsvp-email">Email address</label>
// //                   <input
// //                     id="rsvp-email"
// //                     type="email"
// //                     placeholder="Email Address"
// //                     value={rsvp.email}
// //                     onChange={(e) => setRsvp((r) => ({ ...r, email: e.target.value }))}
// //                     required
// //                   />

// //                   <div style={{ position: 'relative', zIndex: 100 }}>
// //                     <label className="sr-only" htmlFor="rsvp-attending">Will you attend?</label>
// //                     <CustomSelect 
// //                       value={rsvp.attending} 
// //                       options={['Will attend', 'Will not attend', 'Maybe']}
// //                       onChange={(val) => setRsvp((r) => ({ ...r, attending: val }))} 
// //                     />
// //                   </div>

// //                   <motion.button 
// //                     type="submit" 
// //                     className="btn-gold" 
// //                     style={{ width: '100%', padding: '14px', marginTop: '10px' }}
// //                     whileHover={{ scale: 1.02 }}
// //                     whileTap={{ scale: 0.98 }}
// //                   >
// //                     Submit RSVP
// //                   </motion.button>
// //                 </form>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

// //       {/* ── WELL WISHES ── */}
// //       <section id="wishes" className="section wishes-section">
// //         <div className="section-content">
// //           <span className="eyebrow">From Everyone Who Loves Her</span>
// //           <h2 className="section-title">Well Wishes</h2>

// //           <div className="wishes-container">
// //             <div className="featured-wish">
// //               <div className="wish-card featured">
// //                 <p className="wish-text">
// //                   "Fifty years in, and you're still the person everyone calls
// //                   when they need wisdom. Thank you for the patience, the
// //                   standards, and the quiet way you've always shown up for
// //                   people. Here's to the next fifty."
// //                 </p>
// //                 <div className="wish-author">
// //                   <strong>Raphael Chiemeka</strong>
// //                   <span className="wish-rating">
// //                     <Icon.Star width="14" height="14" /> 5.0
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="wishes-grid">
// //               <div className="wish-card">
// //                 <p>"Happy 50th! You're an inspiration to us all."</p>
// //                 <div className="wish-author"><strong>Chidi Okonkwo</strong></div>
// //               </div>
// //               <div className="wish-card">
// //                 <p>"Wishing you continued success and joy. Cheers to 50 years!"</p>
// //                 <div className="wish-author"><strong>Amara Nwosu</strong></div>
// //               </div>
// //               <div className="wish-card">
// //                 <p>"Your leadership has shaped so many careers, mine included."</p>
// //                 <div className="wish-author"><strong>Kunle Adeyemi</strong></div>
// //               </div>
// //               <div className="wish-card">
// //                 <p>"May this new chapter bring even more joy and fulfillment."</p>
// //                 <div className="wish-author"><strong>Zainab Bello</strong></div>
// //               </div>
// //             </div>

// //             <Link to="/messages" className="btn-outline view-all-wishes">
// //               View all &amp; add yours <Icon.Arrow width="16" height="16" />
// //             </Link>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ── Footer ── */}
// //       <footer className="footer">
// //         <div className="footer-content">
// //           <p>© 2026 A Golden Birthday Celebration</p>
// //           <div className="social-links">
// //             {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
// //             <a href="#" aria-label="Instagram"><Icon.Instagram width="20" height="20" /></a>
// //             {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
// //             <a href="#" aria-label="Facebook"><Icon.Facebook width="20" height="20" /></a>
// //             {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
// //             <a href="#" aria-label="YouTube"><Icon.Youtube width="20" height="20" /></a>
// //           </div>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // }




// //Registration

// import React, { useState, useEffect, useRef, useCallback } from 'react';

// import { Link } from 'react-router-dom';

// import { motion, AnimatePresence } from 'framer-motion';

// import './Home.css';

// /**

// * ── Single source of truth ──────────────────────────────────────────────

// */

// const CONFIG = {

// celebrantName: 'Her',

// age: 50,

// eventDate: new Date('2026-09-23T18:00:00+01:00'),

// eventEndLabel: '11:59 PM',

// venueName: 'Bay 2',

// venueArea: 'Aseese Base',

// dressCode: 'Golden Glamour',

// dressCodeSub: 'Black & Gold Attire',

// rsvpDeadline: new Date('2026-09-10T23:59:59+01:00'),

// };

// const dateFormatter = new Intl.DateTimeFormat('en-US', {

// month: 'long',

// day: 'numeric',

// year: 'numeric',

// });

// /* ── Inline Icons ───────── */

// const Icon = {

// Calendar: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <rect x="3" y="5" width="18" height="16" rx="2" />

// <path d="M8 3v4M16 3v4M3 10h18" strokeLinecap="round" />

// </svg>

// ),

// Pin: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <path d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21Z" />

// <circle cx="12" cy="9.5" r="2.4" />

// </svg>

// ),

// Attire: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <path d="M8 4 4 7l2 3 2-1.4V20h8V8.6L18 10l2-3-4-3-2 2h-4L8 4Z" strokeLinejoin="round" />

// </svg>

// ),

// Music: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <path d="M9 18V5l11-2v13" strokeLinecap="round" strokeLinejoin="round" />

// <circle cx="6" cy="18" r="3" />

// <circle cx="17" cy="16" r="3" />

// </svg>

// ),

// Gift: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <rect x="3" y="9" width="18" height="12" rx="1" />

// <path d="M3 9h18M12 9v12M12 9C9.5 9 8 7.3 8 5.7 8 4.2 9 3 10.3 3 12 3 12 6 12 9ZM12 9c2.5 0 4-1.7 4-3.3C16 4.2 15 3 13.7 3 12 3 12 6 12 9Z" />

// </svg>

// ),

// Mail: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <rect x="3" y="5" width="18" height="14" rx="2" />

// <path d="m4 6 8 6 8-6" strokeLinecap="round" strokeLinejoin="round" />

// </svg>

// ),

// Arrow: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...p}>

// <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />

// </svg>

// ),

// ChevronDown: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>

// <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />

// </svg>

// ),

// Star: (p) => (

// <svg viewBox="0 0 24 24" fill="currentColor" {...p}>

// <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.6l-5.9 3 1.2-6.5-4.8-4.6 6.6-.9L12 2.5Z" />

// </svg>

// ),

// Instagram: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <rect x="3" y="3" width="18" height="18" rx="5" />

// <circle cx="12" cy="12" r="4" />

// <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />

// </svg>

// ),

// Facebook: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <path d="M15 21v-8h3l.5-4H15V7c0-1.1.3-2 2-2h1.5V1.4C18.2 1.3 17 1.2 15.7 1.2 12.9 1.2 11 3 11 6v3H8v4h3v8Z" />

// </svg>

// ),

// Crest: (p) => (

// <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>

// <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />

// <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />

// </svg>

// ),

// Youtube: (p) => (

// <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>

// <rect x="2.5" y="5.5" width="19" height="13" rx="3.5" />

// <path d="M10.5 9.5v5l4.5-2.5-4.5-2.5Z" fill="currentColor" stroke="none" />

// </svg>

// ),

// };

// /* ── The Royal Flanks ──────────────────────────────────────────────────

// Rebuilt so each flank is a real box (see .royal-flank in Home.css)

// instead of one absolutely-positioned overlay pinned with calc() math.

// - RoyalFlankDefs: the shared <symbol>-style SVG library (<defs>), 

// rendered exactly once anywhere in the tree. It's invisible (0x0),

// so its position in the DOM doesn't matter.

// - RoyalFlank: one flank's actual content. The SAME markup is used for

// both sides — the right flank is simply mirrored in CSS via

// `.royal-flank--right { transform: scaleX(-1); }`, so there's no need

// to hand-author separate left/right constellation coordinates anymore.

// */

// const FloralOrnament = () => (

// <>

// <svg className="wreath-icon" viewBox="-50 -50 100 100"><use href="#rf-wreath" /></svg>

// <svg className="wing-icon glow-pulse" viewBox="0 0 30 44"><use href="#rf-wing" /></svg>

// <svg className="bloom-icon bloom-icon--1" viewBox="0 0 40 40"><use href="#rf-rose" /></svg>

// <svg className="bloom-icon bloom-icon--2" viewBox="0 0 40 40"><use href="#rf-leaf" /></svg>

// <svg className="bloom-icon bloom-icon--3" viewBox="0 0 40 40"><use href="#rf-leaf" /></svg>

// </>

// );

// const RoyalFlankDefs = () => (

// <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">

// <defs>

// <g id="rf-rose">

// <g stroke="#c6a15b" strokeWidth="1" fill="none" opacity="0.85">

// <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(0 20 20)" />

// <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(60 20 20)" />

// <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(120 20 20)" />

// <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(180 20 20)" />

// <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(240 20 20)" />

// <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(300 20 20)" />

// </g>

// <circle cx="20" cy="20" r="3" fill="#c6a15b" opacity="0.5" />

// </g>


//   <g id="rf-leaf">
//     <path d="M20 4 C30 12, 30 28, 20 36 C10 28, 10 12, 20 4 Z" stroke="#c6a15b" strokeWidth="1" fill="rgba(198,161,91,0.08)" />
//     <line x1="20" y1="6" x2="20" y2="34" stroke="#c6a15b" strokeWidth="0.75" opacity="0.6" />
//   </g>

//   <g id="rf-wing">
//     <g stroke="#c6a15b" strokeWidth="1" fill="rgba(198,161,91,0.06)">
//       <path d="M0 40 C10 30, 15 15, 8 0 C20 10, 22 25, 14 40 Z" transform="rotate(-24 0 40)" />
//       <path d="M0 40 C12 32, 18 18, 12 2 C24 14, 25 28, 16 40 Z" transform="rotate(-12 0 40)" />
//       <path d="M0 40 C14 34, 20 20, 16 4 C27 17, 27 30, 18 40 Z" transform="rotate(0 0 40)" />
//       <path d="M0 40 C14 34, 20 20, 16 4 C27 17, 27 30, 18 40 Z" transform="rotate(12 0 40)" />
//       <path d="M0 40 C12 32, 18 18, 12 2 C24 14, 25 28, 16 40 Z" transform="rotate(24 0 40)" />
//     </g>
//   </g>

//   <g id="rf-wreath">
//     <use href="#rf-leaf" transform="rotate(0)   translate(0,-38) scale(0.55)" />
//     <use href="#rf-rose" transform="rotate(45)  translate(0,-38) scale(0.5)" />
//     <use href="#rf-leaf" transform="rotate(90)  translate(0,-38) scale(0.55)" />
//     <use href="#rf-rose" transform="rotate(135) translate(0,-38) scale(0.5)" />
//     <use href="#rf-leaf" transform="rotate(180) translate(0,-38) scale(0.55)" />
//     <use href="#rf-rose" transform="rotate(225) translate(0,-38) scale(0.5)" />
//     <use href="#rf-leaf" transform="rotate(270) translate(0,-38) scale(0.55)" />
//     <use href="#rf-rose" transform="rotate(315) translate(0,-38) scale(0.5)" />
//   </g>
// </defs>


// </svg>

// );

// const RoyalFlank = ({ side }) => (

// <div className={`royal-flank royal-flank--${side}`} aria-hidden="true">

// <div className="floral-layer">

// <FloralOrnament />

// </div>


// <div className="stardust-field">
//   <span className="north-star" />
// </div>

// <svg className="constellation-lines" viewBox="0 0 300 800" preserveAspectRatio="none">
//   <polyline
//     points="60,90 130,190 80,330 170,430 100,570 150,690"
//     fill="none"
//     stroke="#c6a15b"
//     strokeWidth="1"
//     strokeOpacity="0.3"
//   />
// </svg>


// </div>

// );

// /* ── 3D Premium Particles Component ───────── */

// const PremiumParticles = ({ activeSection, windowSize }) => {

// const isMobile = windowSize.width > 0 && windowSize.width < 768;

// const particleCount = isMobile ? 24 : 45; 

// const particles = React.useMemo(() => {

// return Array.from({ length: particleCount }).map((_, i) => {

// const types = ['particle-orb', 'particle-ribbon', 'particle-ribbon', 'particle-shard'];

// const type = types[Math.floor(Math.random() * types.length)];


//   const size = Math.random() * 20 + 8;
//   const width = type === 'particle-ribbon' ? size * (Math.random() * 1.5 + 2) : size;

//   // THE "GOLDILOCKS" SPEED (2.5s to 4.5s)
//   // Fast enough to not drag on live servers, slow enough to look luxurious.
//   const duration = Math.random() * 2.0 + 2.5; 
  
//   const delay = Math.random() * -8;
//   const drift = (Math.random() - 0.5) * 40;
//   const rotX = `${Math.random() * 1080}deg`;
//   const rotY = `${Math.random() * 1080}deg`;
//   const rotZ = `${Math.random() * 1080}deg`;

//   return {
//     id: i,
//     type,
//     style: {
//       left: `${Math.random() * 100}%`,
//       width: `${width}px`,
//       height: `${size}px`,
//       animationDuration: `${duration}s`,
//       animationDelay: `${delay}s`,
//       filter: 'none',
//       '--drift': drift,
//       '--rotX': rotX,
//       '--rotY': rotY,
//       '--rotZ': rotZ,
//     }
//   };
// });


// }, [particleCount]);

// return (

// <div

// className="premium-particles-container"

// data-section={activeSection}

// >

// {particles.map((p) => (

// <div key={p.id} className={`particle ${p.type}`} style={p.style} />

// ))}

// </div>

// );

// };
// //Golden
// /* ── Custom Royal Select Dropdown ───────── */

// const CustomSelect = ({ value, onChange, options }) => {

// const [isOpen, setIsOpen] = useState(false);

// const dropdownRef = useRef(null);

// useEffect(() => {

// const handleClickOutside = (e) => {

// if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);

// };

// document.addEventListener('mousedown', handleClickOutside);

// return () => document.removeEventListener('mousedown', handleClickOutside);

// }, []);

// return (

// <div className="custom-select-wrapper" ref={dropdownRef}>

// <div className={`custom-select-header ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>

// <span>{value}</span>

// <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>

// <Icon.ChevronDown width="16" height="16" />

// </motion.div>

// </div>

// <AnimatePresence>

// {isOpen && (

// <motion.ul

// className="custom-select-list"

// initial={{ opacity: 0, y: -10 }}

// animate={{ opacity: 1, y: 0 }}

// exit={{ opacity: 0, y: -10 }}

// transition={{ duration: 0.2 }}

// >

// {options.map((opt) => (

// <li key={opt} onClick={() => { onChange(opt); setIsOpen(false); }}>

// {opt}

// </li>

// ))}

// </motion.ul>

// )}

// </AnimatePresence>

// </div>

// );

// };

// const TRACKED_SECTIONS = ['home', 'save-the-date', 'journey', 'details', 'gallery', 'highlights', 'gifts', 'wishes'];

// function useCountdown(target) {

// const [remaining, setRemaining] = useState(() => target.getTime() - Date.now());

// useEffect(() => {

// const tick = () => setRemaining(target.getTime() - Date.now());

// tick();

// const interval = setInterval(tick, 1000 * 30);

// return () => clearInterval(interval);

// }, [target]);

// const clamped = Math.max(remaining, 0);

// const days = Math.floor(clamped / 86400000);

// const hours = Math.floor((clamped % 86400000) / 3600000);

// const minutes = Math.floor((clamped % 3600000) / 60000);

// return { days, hours, minutes, isPast: remaining <= 0 };

// }

// export default function Home() {

// const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });

// const [activeSection, setActiveSection] = useState('home');

// const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
// const sectionEls = useRef({});

// const countdown = useCountdown(CONFIG.eventDate);

// useEffect(() => {

// const handleResize = () =>

// setWindowSize({ width: window.innerWidth, height: window.innerHeight });

// handleResize();

// window.addEventListener('resize', handleResize);


// const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
// setPrefersReducedMotion(motionQuery.matches);
// const handleMotion = (e) => setPrefersReducedMotion(e.matches);
// motionQuery.addEventListener('change', handleMotion);

// return () => {
//   window.removeEventListener('resize', handleResize);
//   motionQuery.removeEventListener('change', handleMotion);
// };


// }, []);

// useEffect(() => {

// const rafRef = { current: null };

// const handleScroll = () => {

// if (rafRef.current) return;

// rafRef.current = requestAnimationFrame(() => {

// rafRef.current = null;

// });

// };

// window.addEventListener('scroll', handleScroll, { passive: true });

// return () => {

// window.removeEventListener('scroll', handleScroll);

// if (rafRef.current) cancelAnimationFrame(rafRef.current);

// };

// }, []);

// useEffect(() => {

// const observer = new IntersectionObserver(

// (entries) => {

// entries.forEach((entry) => {

// if (entry.isIntersecting) setActiveSection(entry.target.id);

// });

// },

// { rootMargin: '-40% 0px -50% 0px', threshold: 0 }

// );

// //gallery
// TRACKED_SECTIONS.forEach((id) => {
//   const el = document.getElementById(id);
//   if (el) {
//     sectionEls.current[id] = el;
//     observer.observe(el);
//   }
// });

// return () => observer.disconnect();


// }, []);

// const scrollToSection = useCallback((sectionId) => {

// const element = document.getElementById(sectionId);

// if (element) element.scrollIntoView({ behavior: 'smooth' });

// }, []);
// return (

// <div className="app-container">


//   {/* FULL 3D FAST PARTICLES FOR ALL DEVICES */}
//   {!prefersReducedMotion && (
//     <PremiumParticles
//       activeSection={activeSection}
//       windowSize={windowSize}
//     />
//   )}

//   {/* ── HOME SECTION ── */}
//   <section id="home" className="hero-banner-section">
//     <div className="hero-image-container">

//       {/* Shared SVG symbol library — rendered once, referenced by both flanks */}
//       <RoyalFlankDefs />

//       {/* THE PORTRAIT ROW: left flank / image / right flank, as real flex children */}
//       <div className="hero-portrait-row">
//         <RoyalFlank side="left" />

//         <div className="hero-image-wrapper">
//           <img
//             src="/assets/photos/hero-portrait.jpg"
//             alt="Celebrant portrait"
//             className="hero-image"
//             loading="eager"
//             fetchPriority="high"
//           />
//         </div>

//         <RoyalFlank side="right" />
//       </div>

//       <div className="hero-connector" aria-hidden="true">
//         <div className="hero-connector-badge">
//           <Icon.Crest />
//         </div>
//       </div>

//       <div className="hero-plaque">
//         <div className="hero-plaque-inner hero-content">
//           <span className="hero-badge reveal" style={{ '--delay': '0.1s' }}>
//             A Milestone Birthday
//           </span>
//           <h1 className="hero-main-title">
//             <span className="title-line reveal" style={{ '--delay': '0.25s' }}>Fifty Years of</span>
//             <span className="title-line-highlight reveal reveal--shimmer" style={{ '--delay': '0.4s' }}>
//               Grace & Purpose
//             </span>
//           </h1>
//           <p className="hero-description reveal" style={{ '--delay': '0.6s' }}>
//             A golden celebration of a life that has shaped, mentored, and
//             inspired billions around the world.
//           </p>
//           <div className="hero-cta reveal" style={{ '--delay': '0.75s' }}>
//             <Link to="/messages" className="btn-gold hero-btn">
//               <Icon.Mail width="18" height="18" /> Leave a Message
//             </Link>
//             <button className="btn-outline hero-btn-outline" onClick={() => scrollToSection('journey')}>
//               Discover Her Journey
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>

//   <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

//   {/* ── SAVE THE DATE SECTION ── */}
//   <section id="save-the-date" className="welcome-section">
//     <div className="welcome-wrapper">
//       <div className="companion-grid">
        
//         <div className="date-panel">
//           <span className="date-panel-corner date-panel-corner--tl" aria-hidden="true" />
//           <span className="date-panel-corner date-panel-corner--tr" aria-hidden="true" />
//           <span className="date-panel-corner date-panel-corner--bl" aria-hidden="true" />
//           <span className="date-panel-corner date-panel-corner--br" aria-hidden="true" />

//           <Icon.Crest className="crest" aria-hidden="true" />

//           <div className="date-panel-main">
//             <span className="eyebrow">Save the Date</span>
//             <h2>{dateFormatter.format(CONFIG.eventDate).toUpperCase()}</h2>
//           </div>

//           {!countdown.isPast ? (
//             <div className="countdown" role="timer" aria-label="Time remaining until the celebration">
//               <div className="countdown-unit">
//                 <span className="countdown-value">{countdown.days}</span>
//                 <span className="countdown-label">Days</span>
//               </div>
//               <div className="countdown-unit">
//                 <span className="countdown-value">{countdown.hours}</span>
//                 <span className="countdown-label">Hours</span>
//               </div>
//               <div className="countdown-unit">
//                 <span className="countdown-value">{countdown.minutes}</span>
//                 <span className="countdown-label">Minutes</span>
//               </div>
//             </div>
//           ) : (
//             <p className="countdown-past">The celebration has begun 🎉</p>
//           )}
//         </div>

//         <div className="companion-note">
//           <span className="date-panel-corner date-panel-corner--tl" aria-hidden="true" />
//           <span className="date-panel-corner date-panel-corner--tr" aria-hidden="true" />
//           <span className="date-panel-corner date-panel-corner--bl" aria-hidden="true" />
//           <span className="date-panel-corner date-panel-corner--br" aria-hidden="true" />

//          <div className="companion-note-photo">
//             <img
//               src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=700&h=880&fit=crop"
//               alt="A golden birthday celebration toast"
//               loading="lazy"
//             />
//           </div>
//           <div className="companion-note-text">
//             <span className="eyebrow">A Note of Welcome</span>
//             <p className="welcome-note-quote">
//               "Grace amplifies efforts — Great strength, Wisdom, decade after decade."
//             </p>
//             <span className="welcome-note-attribution">— With deep appreciation, OCOS & LMP</span>
//           </div>
//         </div>

//       </div>

//       <p className="hero-subtitle">
//         Step inside to explore her journey, share your testimonies, and add
//         your golden wish to the wall.
//       </p>
//       <div className="action-buttons">
//         <Link to="/messages" className="btn-gold">Read the Wishes</Link>
//         <Link to="/avatar" className="btn-outline">Create Your Avatar</Link>
//       </div>
//     </div>
//   </section>

//   <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

//   {/* ── HER JOURNEY ── */}
//   <section id="journey" className="section story-section">
//     <div className="section-content">
//       <span className="eyebrow">Her Journey</span>
//       <h2 className="section-title">Five Decades, One Purpose</h2>

//       <ol className="timeline">
//         <li className="timeline-item">
//           <span className="timeline-index">01</span>
//           <div>
//             <h3>The Foundation</h3>
//             <p>
//               A curious, determined beginning — the values learned early on
//               became the compass for everything that followed.
//             </p>
//           </div>
//         </li>
//         <li className="timeline-item">
//           <span className="timeline-index">02</span>
//           <div>
//             <h3>Building a Career</h3>
//             <p>
//               Years of showing up, taking on what others avoided, and
//               earning trust the honest way.
//             </p>
//           </div>
//         </li>
//         <li className="timeline-item">
//           <span className="timeline-index">03</span>
//           <div>
//             <h3>Leadership & Mentorship</h3>
//             <p>
//               A door held open for every person who needed one — quietly
//               shaping lives far beyond her own.
//             </p>
//           </div>
//         </li>
//         <li className="timeline-item">
//           <span className="timeline-index">04</span>
//           <div>
//             <h3>Today</h3>
//             <p>
//               Fifty years in, still leading, still mentoring, still the
//               first call when someone needs wisdom.
//             </p>
//           </div>
//         </li>
//       </ol>
//     </div>
//   </section>

//   <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

//   {/* ── DETAILS ── */}
//   <section id="details" className="section details-section">
//     <div className="section-content">
//       <span className="eyebrow">Join Us</span>
//       <h2 className="section-title">Event Details</h2>
//       <div className="details-grid">
//         <div className="detail-card">
//           <Icon.Calendar className="detail-icon" />
//           <h3>Date</h3>
//           <p>{dateFormatter.format(CONFIG.eventDate)}</p>
//           <span>6:00 PM – {CONFIG.eventEndLabel}</span>
//         </div>
//         <div className="detail-card">
//           <Icon.Pin className="detail-icon" />
//           <h3>Venue</h3>
//           <p>{CONFIG.venueName}</p>
//           <span>{CONFIG.venueArea}</span>
//         </div>
//         <div className="detail-card">
//           <Icon.Attire className="detail-icon" />
//           <h3>Dress Code</h3>
//           <p>{CONFIG.dressCode}</p>
//           <span>{CONFIG.dressCodeSub}</span>
//         </div>
//         {/* <div className="detail-card">
//           <Icon.Music className="detail-icon" />
//           <h3>Entertainment</h3>
//           <p>Live Band & DJ</p>
//           <span>Plus a few surprise performances</span>
//         </div> */}
//       </div>
//     </div>
//   </section>

//   <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

//   {/* ── GALLERY ── */}
//   <section id="gallery" className="section gallery-section">
//     <div className="section-content">
//       <span className="eyebrow">Memories</span>
//       <h2 className="section-title">Gallery</h2>
//       <div className="gallery-grid">
//         {[
//           { file: 'memory-red-gown-portrait.jpg', alt: 'Radiant in a red sequin gown, holding her award' },
//           { file: 'memory-group-celebration.jpg', alt: 'Surrounded by loved ones in a joyful celebration' },
//           { file: 'memory-stage-award.jpg', alt: 'On stage receiving the award with her team' },
//           { file: 'gallery-peach-feather-gown.jpg', alt: 'In a peach beaded gown with feather sleeves' },
//           { file: 'gallery-white-beaded-gown.jpg', alt: 'In a white beaded gown, side profile' },
//           { file: 'gallery-black-sequin-gown-turn.jpg', alt: 'In a black sequin gown, mid-turn' },
//           { file: 'gallery-blue-sequin-seated.jpg', alt: 'Seated in a blue and silver sequin gown' },
//           { file: 'gallery-brocade-thoughtful.jpg', alt: 'In a blue brocade suit, a thoughtful moment' },
//         ].map((photo, i) => (
//           <div className="gallery-item" key={photo.file}>
//             <img
//               src={`/assets/photos/${photo.file}`}
//               alt={photo.alt}
//               loading="lazy"
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   </section>

//   <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

//   {/* ── GIFTS / RSVP ── */}
//   <section id="gifts" className="section gifts-section">
//     <div className="section-content">
//       <span className="eyebrow">Celebrate With Us</span>
//       <h2 className="section-title">Gifts & RSVP</h2>
//       <div className="gifts-container">
//         <div className="gift-box">
//           <h3><Icon.Gift width="22" height="22" /> Givings</h3>
//           <p>Offerings & Others</p>
//           <ul>
//             <li>Account Name</li>
//             <li>Account Number</li>
//             <li>Espee & Code</li>
//             <li>God Bless You.</li>
//           </ul>
//         </div>

//         <div className="rsvp-box">
//           <h3>Staff Registration</h3>
//           <p>
//             All staff are invited to the Thanksgiving Service. Register to
//             receive your personal registration code and QR pass.
//           </p>

//           <Link
//             to="/registration"
//             className="btn-gold"
//             style={{
//               width: '100%',
//               padding: '14px',
//               marginTop: '10px',
//               display: 'inline-flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               boxSizing: 'border-box',
//               textDecoration: 'none',
//             }}
//           >
//             Register for Thanksgiving Service
//           </Link>
//         </div>
//       </div>
//     </div>
//   </section>

//   <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

//   {/* ── WELL WISHES ── */}
//   <section id="wishes" className="section wishes-section">
//     <div className="section-content">
//       <span className="eyebrow">From Everyone Who Loves Her</span>
//       <h2 className="section-title">Well Wishes</h2>

//       <div className="wishes-container">
//         <div className="featured-wish">
//           <div className="wish-card featured">
//             <p className="wish-text">
//               "Fifty years in, and you're still the person everyone calls
//               when they need wisdom. Thank you for the patience, the
//               standards, and the quiet way you've always shown up for
//               people. Here's to the next fifty."
//             </p>
//             <div className="wish-author">
//               <strong>Raphael Chiemeka</strong>
//               <span className="wish-rating">
//                 <Icon.Star width="14" height="14" /> 5.0
//               </span>
//             </div>
//           </div>
//         </div>

//         <div className="wishes-grid">
//           <div className="wish-card">
//             <p>"Happy 50th! You're an inspiration to us all."</p>
//             <div className="wish-author"><strong>Chidi Okonkwo</strong></div>
//           </div>
//           <div className="wish-card">
//             <p>"Wishing you continued success and joy. Cheers to 50 years!"</p>
//             <div className="wish-author"><strong>Amara Nwosu</strong></div>
//           </div>
//           <div className="wish-card">
//             <p>"Your leadership has shaped so many careers, mine included."</p>
//             <div className="wish-author"><strong>Kunle Adeyemi</strong></div>
//           </div>
//           <div className="wish-card">
//             <p>"May this new chapter bring even more joy and fulfillment."</p>
//             <div className="wish-author"><strong>Zainab Bello</strong></div>
//           </div>
//         </div>

//         <Link to="/messages" className="btn-outline view-all-wishes">
//           View all & add yours <Icon.Arrow width="16" height="16" />
//         </Link>
//       </div>
//     </div>
//   </section>

//   {/* ── Footer ── */}
//   <footer className="footer">
//     <div className="footer-content">
//       <p>© 2026 A Golden Birthday Celebration</p>
//       <div className="social-links">
//         {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
//         <a href="#" aria-label="Instagram"><Icon.Instagram width="20" height="20" /></a>
//         {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
//         <a href="#" aria-label="Facebook"><Icon.Facebook width="20" height="20" /></a>
//         {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
//         <a href="#" aria-label="YouTube"><Icon.Youtube width="20" height="20" /></a>
//       </div>
//     </div>
//   </footer>
// </div>


// );

// }

//Gallery
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './Home.css';

/**
* ── Single source of truth ──────────────────────────────────────────────
*/
const CONFIG = {
  celebrantName: 'Her',
  age: 50,
  eventDate: new Date('2026-09-23T18:00:00+01:00'),
  eventEndLabel: '11:59 PM',
  venueName: 'Bay 4',
  venueArea: 'Aseese Base',
  dressCode: 'Golden Glamour',
  dressCodeSub: 'White Attire',
  rsvpDeadline: new Date('2026-09-10T23:59:59+01:00'),
};

const API_URL = process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

/* ── Inline Icons ───────── */
const Icon = {
  Calendar: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 10h18" strokeLinecap="round" />
    </svg>
  ),
  Pin: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <path d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21Z" />
      <circle cx="12" cy="9.5" r="2.4" />
    </svg>
  ),
  Attire: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <path d="M8 4 4 7l2 3 2-1.4V20h8V8.6L18 10l2-3-4-3-2 2h-4L8 4Z" strokeLinejoin="round" />
    </svg>
  ),
  Music: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <path d="M9 18V5l11-2v13" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="17" cy="16" r="3" />
    </svg>
  ),
  Gift: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <rect x="3" y="9" width="18" height="12" rx="1" />
      <path d="M3 9h18M12 9v12M12 9C9.5 9 8 7.3 8 5.7 8 4.2 9 3 10.3 3 12 3 12 6 12 9ZM12 9c2.5 0 4-1.7 4-3.3C16 4.2 15 3 13.7 3 12 3 12 6 12 9Z" />
    </svg>
  ),
  Mail: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 6 8 6 8-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Arrow: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...p}>
      <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevronDown: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Star: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.6l-5.9 3 1.2-6.5-4.8-4.6 6.6-.9L12 2.5Z" />
    </svg>
  ),
  Instagram: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
  Facebook: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <path d="M15 21v-8h3l.5-4H15V7c0-1.1.3-2 2-2h1.5V1.4C18.2 1.3 17 1.2 15.7 1.2 12.9 1.2 11 3 11 6v3H8v4h3v8Z" />
    </svg>
  ),
  Crest: (p) => (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
      <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
      <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
    </svg>
  ),
  Youtube: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...p}>
      <rect x="2.5" y="5.5" width="19" height="13" rx="3.5" />
      <path d="M10.5 9.5v5l4.5-2.5-4.5-2.5Z" fill="currentColor" stroke="none" />
    </svg>
  ),
};

/* ── The Royal Flanks ────────────────────────────────────────────────── */
const FloralOrnament = () => (
  <>
    <svg className="wreath-icon" viewBox="-50 -50 100 100"><use href="#rf-wreath" /></svg>
    <svg className="wing-icon glow-pulse" viewBox="0 0 30 44"><use href="#rf-wing" /></svg>
    <svg className="bloom-icon bloom-icon--1" viewBox="0 0 40 40"><use href="#rf-rose" /></svg>
    <svg className="bloom-icon bloom-icon--2" viewBox="0 0 40 40"><use href="#rf-leaf" /></svg>
    <svg className="bloom-icon bloom-icon--3" viewBox="0 0 40 40"><use href="#rf-leaf" /></svg>
  </>
);

const RoyalFlankDefs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <g id="rf-rose">
        <g stroke="#c6a15b" strokeWidth="1" fill="none" opacity="0.85">
          <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(0 20 20)" />
          <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(60 20 20)" />
          <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(120 20 20)" />
          <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(180 20 20)" />
          <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(240 20 20)" />
          <ellipse cx="20" cy="12" rx="5" ry="9" transform="rotate(300 20 20)" />
        </g>
        <circle cx="20" cy="20" r="3" fill="#c6a15b" opacity="0.5" />
      </g>
      <g id="rf-leaf">
        <path d="M20 4 C30 12, 30 28, 20 36 C10 28, 10 12, 20 4 Z" stroke="#c6a15b" strokeWidth="1" fill="rgba(198,161,91,0.08)" />
        <line x1="20" y1="6" x2="20" y2="34" stroke="#c6a15b" strokeWidth="0.75" opacity="0.6" />
      </g>
      <g id="rf-wing">
        <g stroke="#c6a15b" strokeWidth="1" fill="rgba(198,161,91,0.06)">
          <path d="M0 40 C10 30, 15 15, 8 0 C20 10, 22 25, 14 40 Z" transform="rotate(-24 0 40)" />
          <path d="M0 40 C12 32, 18 18, 12 2 C24 14, 25 28, 16 40 Z" transform="rotate(-12 0 40)" />
          <path d="M0 40 C14 34, 20 20, 16 4 C27 17, 27 30, 18 40 Z" transform="rotate(0 0 40)" />
          <path d="M0 40 C14 34, 20 20, 16 4 C27 17, 27 30, 18 40 Z" transform="rotate(12 0 40)" />
          <path d="M0 40 C12 32, 18 18, 12 2 C24 14, 25 28, 16 40 Z" transform="rotate(24 0 40)" />
        </g>
      </g>
      <g id="rf-wreath">
        <use href="#rf-leaf" transform="rotate(0)   translate(0,-38) scale(0.55)" />
        <use href="#rf-rose" transform="rotate(45)  translate(0,-38) scale(0.5)" />
        <use href="#rf-leaf" transform="rotate(90)  translate(0,-38) scale(0.55)" />
        <use href="#rf-rose" transform="rotate(135) translate(0,-38) scale(0.5)" />
        <use href="#rf-leaf" transform="rotate(180) translate(0,-38) scale(0.55)" />
        <use href="#rf-rose" transform="rotate(225) translate(0,-38) scale(0.5)" />
        <use href="#rf-leaf" transform="rotate(270) translate(0,-38) scale(0.55)" />
        <use href="#rf-rose" transform="rotate(315) translate(0,-38) scale(0.5)" />
      </g>
    </defs>
  </svg>
);

const RoyalFlank = ({ side }) => (
  <div className={`royal-flank royal-flank--${side}`} aria-hidden="true">
    <div className="floral-layer">
      <FloralOrnament />
    </div>
    <div className="stardust-field">
      <span className="north-star" />
    </div>
    <svg className="constellation-lines" viewBox="0 0 300 800" preserveAspectRatio="none">
      <polyline
        points="60,90 130,190 80,330 170,430 100,570 150,690"
        fill="none"
        stroke="#c6a15b"
        strokeWidth="1"
        strokeOpacity="0.3"
      />
    </svg>
  </div>
);

/* ── 3D Premium Particles Component ───────── */
const PremiumParticles = ({ activeSection, windowSize }) => {
  const isMobile = windowSize.width > 0 && windowSize.width < 768;
  const particleCount = isMobile ? 24 : 45; 

  const particles = React.useMemo(() => {
    return Array.from({ length: particleCount }).map((_, i) => {
      const types = ['particle-orb', 'particle-ribbon', 'particle-ribbon', 'particle-shard'];
      const type = types[Math.floor(Math.random() * types.length)];

      const size = Math.random() * 20 + 8;
      const width = type === 'particle-ribbon' ? size * (Math.random() * 1.5 + 2) : size;

      // Fast enough to not drag on live servers, slow enough to look luxurious on desktop.
      const duration = isMobile 
        ? Math.random() * 1.2 + 1.2  // Mobile: 1.2s to 2.4s
        : Math.random() * 2.0 + 2.5; // Desktop: 2.5s to 4.5s
      
      const delay = Math.random() * -8;
      const drift = (Math.random() - 0.5) * 40;
      const rotX = `${Math.random() * 1080}deg`;
      const rotY = `${Math.random() * 1080}deg`;
      const rotZ = `${Math.random() * 1080}deg`;

      return {
        id: i,
        type,
        style: {
          left: `${Math.random() * 100}%`,
          width: `${width}px`,
          height: `${size}px`,
          animationDuration: `${duration}s`,
          animationDelay: `${delay}s`,
          filter: 'none',
          '--drift': drift,
          '--rotX': rotX,
          '--rotY': rotY,
          '--rotZ': rotZ,
        }
      };
    });
  }, [particleCount, isMobile]);

  return (
    <div className="premium-particles-container" data-section={activeSection}>
      {particles.map((p) => (
        <div key={p.id} className={`particle ${p.type}`} style={p.style} />
      ))}
    </div>
  );
};

/* ── Custom Royal Select Dropdown ───────── */
const CustomSelect = ({ value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="custom-select-wrapper" ref={dropdownRef}>
      <div className={`custom-select-header ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <span>{value}</span>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
          <Icon.ChevronDown width="16" height="16" />
        </motion.div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            className="custom-select-list"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            {options.map((opt) => (
              <li key={opt} onClick={() => { onChange(opt); setIsOpen(false); }}>
                {opt}
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

const TRACKED_SECTIONS = ['home', 'save-the-date', 'journey', 'details', 'gallery', 'highlights', 'gifts', 'wishes'];

function useCountdown(target) {
  const [remaining, setRemaining] = useState(() => target.getTime() - Date.now());

  useEffect(() => {
    const tick = () => setRemaining(target.getTime() - Date.now());
    tick();
    const interval = setInterval(tick, 1000 * 30);
    return () => clearInterval(interval);
  }, [target]);

  const clamped = Math.max(remaining, 0);
  const days = Math.floor(clamped / 86400000);
  const hours = Math.floor((clamped % 86400000) / 3600000);
  const minutes = Math.floor((clamped % 3600000) / 60000);

  return { days, hours, minutes, isPast: remaining <= 0 };
}

export default function Home() {
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const [activeSection, setActiveSection] = useState('home');
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const sectionEls = useRef({});
  const countdown = useCountdown(CONFIG.eventDate);

  const [greetings, setGreetings] = useState([]);
  const [greetingsLoading, setGreetingsLoading] = useState(true);
  const [greetingsError, setGreetingsError] = useState('');

  useEffect(() => {
    const handleResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    handleResize();
    window.addEventListener('resize', handleResize);

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(motionQuery.matches);
    const handleMotion = (e) => setPrefersReducedMotion(e.matches);
    motionQuery.addEventListener('change', handleMotion);

    return () => {
      window.removeEventListener('resize', handleResize);
      motionQuery.removeEventListener('change', handleMotion);
    };
  }, []);

  useEffect(() => {
    const rafRef = { current: null };
    const handleScroll = () => {
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );

    TRACKED_SECTIONS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        sectionEls.current[id] = el;
        observer.observe(el);
      }
    });

    return () => observer.disconnect();
  }, []);

  const loadGreetings = useCallback(async () => {
    try {
      setGreetingsLoading(true);
      setGreetingsError('');
      const response = await fetch(`${API_URL}/api/birthday/messages`);
      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Unable to load greetings right now.');
      }

      const items = Array.isArray(result.data) ? result.data : [];
      const realTextGreetings = items
        .filter(
          (message) =>
            message?.type === 'text' &&
            typeof message?.text === 'string' &&
            message.text.trim() &&
            typeof message?.author === 'string' &&
            message.author.trim()
        )
        .slice(0, 5);

      setGreetings(realTextGreetings);
    } catch (error) {
      setGreetings([]);
      setGreetingsError(error.message || 'Unable to load greetings right now.');
    } finally {
      setGreetingsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGreetings();
  }, [loadGreetings]);

  const featuredGreeting = greetings[0] || null;
  const otherGreetings = greetings.slice(1, 5);

  const scrollToSection = useCallback((sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div className="app-container">
      {/* FULL 3D FAST PARTICLES FOR ALL DEVICES */}
      {!prefersReducedMotion && (
        <PremiumParticles activeSection={activeSection} windowSize={windowSize} />
      )}

      {/* ── HOME SECTION ── */}
      <section id="home" className="hero-banner-section">
        <div className="hero-image-container">
          <RoyalFlankDefs />
          <div className="hero-portrait-row">
            <RoyalFlank side="left" />
            <div className="hero-image-wrapper">
              <img
                src="\assets\photos\PBA_14.png"
                alt="Celebrant portrait"
                className="hero-image"
                loading="eager"
                fetchPriority="high"
              />
            </div>
            <RoyalFlank side="right" />
          </div>

          <div className="hero-connector" aria-hidden="true">
            <div className="hero-connector-badge">
              <Icon.Crest />
            </div>
          </div>

          <div className="hero-plaque">
            <div className="hero-plaque-inner hero-content">
              <span className="hero-badge reveal" style={{ '--delay': '0.1s' }}>
                A Milestone Birthday
              </span>
              <h1 className="hero-main-title">
                <span className="title-line reveal" style={{ '--delay': '0.25s' }}>Fifty Years of</span>
                <span className="title-line-highlight reveal reveal--shimmer" style={{ '--delay': '0.4s' }}>
                  Grace & Purpose
                </span>
              </h1>
              <p className="hero-description reveal" style={{ '--delay': '0.6s' }}>
                A golden celebration of a life that has shaped, mentored, and inspired billions around the world.
              </p>
              <div className="hero-cta reveal" style={{ '--delay': '0.75s' }}>
                <Link to="/messages" className="btn-gold hero-btn">
                  <Icon.Mail width="18" height="18" /> Leave a Message
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

      {/* ── SAVE THE DATE SECTION ── */}
      <section id="save-the-date" className="welcome-section">
        <div className="welcome-wrapper">
          <div className="companion-grid">
            <div className="date-panel">
              <span className="date-panel-corner date-panel-corner--tl" aria-hidden="true" />
              <span className="date-panel-corner date-panel-corner--tr" aria-hidden="true" />
              <span className="date-panel-corner date-panel-corner--bl" aria-hidden="true" />
              <span className="date-panel-corner date-panel-corner--br" aria-hidden="true" />
              <Icon.Crest className="crest" aria-hidden="true" />
              <div className="date-panel-main">
                <span className="eyebrow">Save the Date</span>
                <h2>{dateFormatter.format(CONFIG.eventDate).toUpperCase()}</h2>
              </div>
              {!countdown.isPast ? (
                <div className="countdown" role="timer" aria-label="Time remaining until the celebration">
                  <div className="countdown-unit">
                    <span className="countdown-value">{countdown.days}</span>
                    <span className="countdown-label">Days</span>
                  </div>
                  <div className="countdown-unit">
                    <span className="countdown-value">{countdown.hours}</span>
                    <span className="countdown-label">Hours</span>
                  </div>
                  <div className="countdown-unit">
                    <span className="countdown-value">{countdown.minutes}</span>
                    <span className="countdown-label">Minutes</span>
                  </div>
                </div>
              ) : (
                <p className="countdown-past">The celebration has begun 🎉</p>
              )}
            </div>

            <div className="companion-note">
              <span className="date-panel-corner date-panel-corner--tl" aria-hidden="true" />
              <span className="date-panel-corner date-panel-corner--tr" aria-hidden="true" />
              <span className="date-panel-corner date-panel-corner--bl" aria-hidden="true" />
              <span className="date-panel-corner date-panel-corner--br" aria-hidden="true" />
              <div className="companion-note-photo">
                <img
                  src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=700&h=880&fit=crop"
                  alt="A golden birthday celebration toast"
                  loading="lazy"
                />
              </div>
              <div className="companion-note-text">
                <span className="eyebrow">A Note of Welcome</span>
                <p className="welcome-note-quote">
                  "Grace amplifies efforts — Great strength, Wisdom, decade after decade."
                </p>
                <span className="welcome-note-attribution">— With deep appreciation, OCOS & LMP</span>
              </div>
            </div>
          </div>

          <p className="hero-subtitle">
            Share your testimonies, and add your message to the wall.
          </p>
          <div className="action-buttons">
            <Link to="/messages" className="btn-gold">Read the Messages</Link>
            <Link to="/avatar" className="btn-outline">Create Your Avatar</Link>
          </div>
        </div>
      </section>

      <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

      {/* ── DETAILS ── */}
      <section id="details" className="section details-section">
        <div className="section-content">
          <span className="eyebrow">Join Us</span>
          <h2 className="section-title">Event Details</h2>
          <div className="details-grid">
            <div className="detail-card">
              <Icon.Calendar className="detail-icon" />
              <h3>Date</h3>
              <p>{dateFormatter.format(CONFIG.eventDate)}</p>
              <span>10:00 AM</span>
            </div>
            <div className="detail-card">
              <Icon.Pin className="detail-icon" />
              <h3>Venue</h3>
              <p>{CONFIG.venueName}</p>
              <span>{CONFIG.venueArea}</span>
            </div>
            <div className="detail-card">
              <Icon.Attire className="detail-icon" />
              <h3>Dress Code</h3>
              <p>{CONFIG.dressCode}</p>
              <span>{CONFIG.dressCodeSub}</span>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

      {/* ── GALLERY ── */}
      <section id="gallery" className="section gallery-section">
        <div className="section-content">
          <span className="eyebrow">Memories</span>
          <h2 className="section-title">Gallery</h2>
          <div className="gallery-grid">
            {[
              { file: 'PBA_10.png', alt: 'In a red velvet and gold top, resting gracefully' },
              { file: 'memory-group-celebration.jpg', alt: 'Surrounded by loved ones in a joyful celebration' },
              { file: 'PBA_18.png', alt: 'In a lavender pearl-studded suit' },
              { file: 'memory-red-gown-portrait.jpg', alt: 'Radiant in a red sequin gown, holding an award' },
              { file: 'PBA_19.png', alt: 'Elegant in a blue pearl-studded suit' },
              { file: 'memory-stage-award.jpg', alt: 'On stage receiving the award with her team' },
              { file: 'PBA_3.png', alt: 'In a stunning black and silver-studded dress' },
              { file: 'PBA_14.png', alt: 'In a red velvet and gold peplum top' },
              { file: 'image_1732135717 (1).jpg', alt: 'In a red velvet and gold peplum top' },
              { file: 'image_1733847849.jpg', alt: 'In a red velvet and gold peplum top' },
              { file: '3A3A9789.JPG', alt: 'In a red velvet and gold peplum top' },
              { file: 'CX5A2257.JPG', alt: 'In a red velvet and gold peplum top' },
            ].map((photo) => (
              <div className="gallery-item" key={photo.file}>
                <img
                  src={`/assets/photos/${photo.file}`}
                  alt={photo.alt}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>
{/* ── OFFERING & GIFTS ── */}
{/* ── OFFERING & GIFTS ── */}
<section id="gifts" className="section gifts-section">
        <div className="section-content">
          <span className="eyebrow">A Show of Love &amp; Honour</span>
          <h2 className="section-title">Send a Gift to the Chief of Staff</h2>
          <p className="gifts-intro">
          
          </p>

          <div className="gifts-container">
            <div className="gift-box gift-box--espees">
              <div className="gift-box-header">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" />
                  <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
                  <circle cx="18" cy="12" r="1" />
                </svg>
                

                <h3> To Give Using Espees</h3>
              </div>
              
              
              
              <div className="espees-code-banner">
              <strong className="espees-banner-value">ESPEES CODE : </strong>
                <strong className="espees-banner-value">OCOS FIN</strong>
              </div>

              <p className="gift-closing-note">
                <em>Thank you for your liquid love. God bless you abundantly!</em>
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" aria-hidden="true"><Icon.Crest /></div>

      {/* ── GREETINGS FROM AROUND THE WORLD ── */}
      <section id="wishes" className="section wishes-section">
        <div className="section-content">
          <span className="eyebrow">Messages of Love</span>
          <h2 className="section-title">Greetings from Around the World</h2>

          <div className="wishes-container">
            {greetingsLoading && (
              <div className="home-greetings-status">
                <span className="home-greetings-loader" aria-hidden="true" />
                <p>Gathering greetings from around the world…</p>
              </div>
            )}

            {!greetingsLoading && greetingsError && (
              <div className="home-greetings-status home-greetings-status--error">
                <p>{greetingsError}</p>
                <button type="button" className="home-greetings-retry" onClick={loadGreetings}>
                  Try Again
                </button>
              </div>
            )}

            {!greetingsLoading && !greetingsError && greetings.length === 0 && (
              <div className="home-greetings-empty">
                <Icon.Mail width="25" height="25" />
                <h3>No greetings yet</h3>
                <p>Be the first to send a birthday greeting and let your message become part of this celebration.</p>
                <Link to="/messages" className="btn-gold">Leave a Greeting</Link>
              </div>
            )}

            {!greetingsLoading && !greetingsError && featuredGreeting && (
              <>
                <div className="featured-wish">
                  <motion.div
                    className="wish-card featured"
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5 }}
                  >
                    <span className="featured-greeting-label">
                      <Icon.Star width="13" height="13" />
                      Featured Greeting
                    </span>
                    <p className="wish-text">“{featuredGreeting.text}”</p>
                    <div className="wish-author">
                      <strong>{featuredGreeting.author}</strong>
                    </div>
                  </motion.div>
                </div>

                {otherGreetings.length > 0 && (
                  <div className="wishes-grid">
                    {otherGreetings.map((greeting, index) => (
                      <motion.div
                        className="wish-card"
                        key={greeting._id}
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.15 }}
                        transition={{ duration: 0.4, delay: index * 0.06 }}
                      >
                        <p>“{greeting.text}”</p>
                        <div className="wish-author">
                          <strong>{greeting.author}</strong>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                )}

                <div className="home-greetings-actions">
                  <Link to="/messages" className="btn-outline view-all-wishes">
                    View all greetings
                    <Icon.Arrow width="16" height="16" />
                  </Link>
                  <Link to="/messages" className="btn-gold">Leave a Greeting</Link>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="footer">
        <div className="footer-content">
          <p>© 2026 A Golden Birthday Celebration</p>
          <div className="social-links">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" aria-label="Instagram"><Icon.Instagram width="20" height="20" /></a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" aria-label="Facebook"><Icon.Facebook width="20" height="20" /></a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" aria-label="YouTube"><Icon.Youtube width="20" height="20" /></a>
          </div>
        </div>
      </footer>
    </div>
  );
}